"use client";

import {useEffect} from "react";

import {AnalyticsService} from "@/shared/services/analytics/analytics.service";
import type {ViewItemPayload} from "@/shared/services/analytics/analytics.service";

export function ViewItemTracker(payload: ViewItemPayload): null {
    useEffect(() => {
        AnalyticsService().trackViewItem(payload);
    }, []);

    return null;
}
